import { useEffect, useState } from "react";
export const usePasskeyBrowserSupport = () => {
    const [stateIsUserVerifyingPlatformAuthenticatorAvailable, setStateIsUserVerifyingPlatformAuthenticatorAvailable] = useState(null);
    const [stateIsConditionalMediationAvailable, setStateIsConditionalMediationAvailable] = useState(null);
    useEffect(() => {
        // Availability of `window.PublicKeyCredential` means WebAuthn is usable.
        if (window.PublicKeyCredential) {
            // Check if user verifying platform authenticator is available.
            // `isUserVerifyingPlatformAuthenticatorAvailable` means the feature detection is usable.
            if (PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable) {
                PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()
                    .then(result => {
                    setStateIsUserVerifyingPlatformAuthenticatorAvailable(result);
                });
            }
            // `isConditionalMediationAvailable` means the feature detection is usable.
            if (PublicKeyCredential.isConditionalMediationAvailable) {
                PublicKeyCredential.isConditionalMediationAvailable()
                    .then(result => {
                    setStateIsConditionalMediationAvailable(result);
                });
            }
        }
    }, []);
    return {
        publicKeyCredentialAvailable: window.PublicKeyCredential,
        userVerifyingPlatformAuthenticatorAvailable: stateIsUserVerifyingPlatformAuthenticatorAvailable,
        conditionalMediationAvailable: stateIsConditionalMediationAvailable
    };
};
export default usePasskeyBrowserSupport;
